module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/no-important.js
// module id = 33
// module chunks = 1 3 4 5 6 7 8 9 10 11 12